import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import NotFoundPage from '@/app/ErrorHandling/NotFoundPage';

interface CustomerRouteProtectionProps {
  children: React.ReactNode;
  allowCustomerUsers?: boolean;
  redirectTo?: string;
}

const CustomerRouteProtection = ({
  children,
  allowCustomerUsers = false,
  redirectTo = '/login',
}: CustomerRouteProtectionProps) => {
  const { isAuthenticated, isCustomerUser } = useAuthStore();
  const location = useLocation();

  // If not authenticated, redirect to login with current URL as redirect parameter
  if (!isAuthenticated) {
    const currentUrl = location.pathname + location.search;
    const redirectUrl = `${redirectTo}?redirect=${encodeURIComponent(currentUrl)}`;
    return <Navigate to={redirectUrl} replace />;
  }

  // If customer user is trying to access unauthorized routes, show 404
  if (isCustomerUser && !allowCustomerUsers) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export default CustomerRouteProtection;